// extracted by mini-css-extract-plugin
export default {"label":"JcRAqhr2ofcwT4sWo0DI","negative":"yDNJwWeDYRoEGdppOAzd","positive":"lDtMNnAYNmcUTxbWv7qX"};